/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Voice_Agents_Tlm_1Inputs */

const en_svc_ai_voice_agents_tlm_1 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`telephony`)
};

const ar_svc_ai_voice_agents_tlm_1 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الاتصالات`)
};

const bn_svc_ai_voice_agents_tlm_1 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`টেলিফোনি`)
};

const de_svc_ai_voice_agents_tlm_1 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefonie`)
};

const es_svc_ai_voice_agents_tlm_1 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefonía`)
};

const fr_svc_ai_voice_agents_tlm_1 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléphonie`)
};

const pt_svc_ai_voice_agents_tlm_1 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefonia`)
};

const zh_svc_ai_voice_agents_tlm_1 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电话线路`)
};

const tr_svc_ai_voice_agents_tlm_1 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

const ru_svc_ai_voice_agents_tlm_1 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Телефония`)
};

const pl_svc_ai_voice_agents_tlm_1 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefonia`)
};

/**
* | output |
* | --- |
* | "telephony" |
*
* @param {Svc_Ai_Voice_Agents_Tlm_1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_voice_agents_tlm_1 = /** @type {((inputs?: Svc_Ai_Voice_Agents_Tlm_1Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Voice_Agents_Tlm_1Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_voice_agents_tlm_1(inputs)
	if (locale === "bn") return bn_svc_ai_voice_agents_tlm_1(inputs)
	if (locale === "de") return de_svc_ai_voice_agents_tlm_1(inputs)
	if (locale === "es") return es_svc_ai_voice_agents_tlm_1(inputs)
	if (locale === "fr") return fr_svc_ai_voice_agents_tlm_1(inputs)
	if (locale === "pt") return pt_svc_ai_voice_agents_tlm_1(inputs)
	if (locale === "zh") return zh_svc_ai_voice_agents_tlm_1(inputs)
	if (locale === "tr") return tr_svc_ai_voice_agents_tlm_1(inputs)
	if (locale === "ru") return ru_svc_ai_voice_agents_tlm_1(inputs)
	if (locale === "pl") return pl_svc_ai_voice_agents_tlm_1(inputs)
	return en_svc_ai_voice_agents_tlm_1(inputs)
});
export { svc_ai_voice_agents_tlm_1 as "svc_ai-voice-agents_tlm_1" }